import { useState } from "react";
import { Badge, IconButton, ListItemIcon, Menu, MenuItem, MenuList, Typography} from "@mui/material";
import { DaymapIcon, DaymapIconType, useSettings} from "daymap-react";
import { useNavigate } from "react-router-dom";
import { Browser } from "@capacitor/browser";

export const QuickActionButton: React.FC = () => {
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
    const [quickActionMenuOpen, setQuickActionMenuOpen] = useState(Boolean(menuAnchor));

    const buttonClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
        setMenuAnchor(event.currentTarget);
        setQuickActionMenuOpen(true);
    }

    return <>
    <Badge overlap="circular" anchorOrigin={{ vertical: 'bottom' }}>
        <IconButton disableFocusRipple aria-label="quickactions" variant="background" onClick={buttonClicked}>
            <DaymapIcon iconType={DaymapIconType.QuickAction} />
        </IconButton>
        <QuickActionMenu anchorEl={menuAnchor} open={quickActionMenuOpen} onClose={() => setQuickActionMenuOpen(false)} />
    </Badge>
    </>;
}

export const QuickActionMenu: React.FC<{
    anchorEl: HTMLElement | null; 
    open: boolean; onClose: () => void;  
    anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right'; }; 
    transformOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right';};
}> = ({ anchorEl, open, onClose, anchorOrigin, transformOrigin }) => {
    const navigate = useNavigate();
    const { settings } = useSettings();
    if (!settings) return;
    const quickActions = settings.quickActionList || [];

    const menuClicked = async (route:string) => {
        onClose();
        if (!route.includes('http'))
            navigate(route);
        else
            await Browser.open({ url: route });  
    }

    return <>
    <Menu anchorEl={anchorEl} open={Boolean(open)} id="messaging-menu" onClose={onClose} {...(anchorOrigin ? { anchorOrigin } : {})} {...(transformOrigin ? { transformOrigin } : {})} >
        <MenuList>
            {quickActions.map((i, index) => {
                return <MenuItem key={i.Route || i.Label || `item-${index}`} {...(i.Route ? { onClick: () => menuClicked(i.Route as string) } : {})} >
                    <ListItemIcon>
                        <DaymapIcon fontSize="small" iconType={DaymapIconType[i.IconName as keyof typeof DaymapIconType]} />
                    </ListItemIcon>
                    <Typography variant="body2" noWrap>{i.Label}</Typography>
                </MenuItem>
            })}
        </MenuList>
    </Menu>
    </>;
}